import React, { useState, setState } from "react";
import "./card.css";
import ViewInfluencer from './viewInfluencer';
import userImagesvg from '../images/user.svg'

function Card({ Name, Image, Age, Gender, Location, Followers, Tags, Profile, Link }) {
    return (
        <div className="out1">
            {/* <div className="in1">
            </div> */}
            <div className="in1">
                <img src={Image} className="img12"></img>
                <img src={Profile} className="pro1"></img>
                <div className='rating-div'>
                        <span className='rating'>5</span>
                        <img src='/images/star.png' alt='star' className='star' width='30px' height='30px'></img>
                    </div>
            </div>
            <div className="in2">
                {Name} <br />
                {Gender} | {Age} | {Location} <br />
                {Tags}
            </div>
            <div className='but-on'>
                {/* <div className='col'> */}
                    <div className='followers'>
                        <img src={userImagesvg} className="usersvg"></img>{Followers}
                    </div>

                {/* </div> */}
                {/* <div className='col'> */}
                    <button type="submit" className="pro">
                        {/* <a href={`/view-influencer/${Name}${Profile}${Tags}`}>View Profile</a> */}
                        <a href='/view-influencer' className='H-txt'>View Profile</a>

                        {/* <a href="/view-influencer?name=`${Name}`&profile=`${Profile}`&tags=`${Tags}`">View Profile</a> */}

                        {/* <Link to={{
                            pathname: '/view-influencer',
                            state: {
                                Name: { Name },
                                Profile: { Profile },
                                Tags: { Tags }
                            }
                        }} /> */}

                        {/* <Link to="/view-influencer" state={{ Name:{Name},
                                Profile:{Profile},
                                Tags:{Tags} }}>next step</Link> */}
                        {/* <Link
                            to="/view-influencer"
                            params={{
                                Name:{Name},
                                Profile:{Profile},
                                Tags:{Tags}
                            }}
                        /> */}
                        {/* View Profile */}
                        {/* <div className='cols2'>
                            <ViewInfluencer
                                Name={Name}
                                Profile={Profile}
                                Tags={Tags}
                            />
                        </div> */}
                    </button>
                {/* </div> */}
            </div>
        </div>
    //   </div>
    // </div>
  );
}

export default Card;
